// extracted by mini-css-extract-plugin
module.exports = {"item":"FooterLink-module--item--1A1x3","link":"FooterLink-module--link--30Rym","button":"FooterLink-module--button--384C8"};